import { Prompt } from '@/components/MainContent';
import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

interface SearchProps {
  searchResults: Prompt[];
  setSearchResults: (value: Prompt[]) => void;
  hasActiveSearch: boolean;
  setHasActiveSearch: (active: boolean) => void;
}

const SearchContext = createContext<SearchProps | undefined>(undefined);

export const SearchProvider: FC<PropsWithChildren> = ({ children }) => {
  const [searchResults, setSearchResults] = useState<Prompt[]>([]);
  const [hasActiveSearch, setHasActiveSearch] = useState<boolean>(false);

  return (
    <SearchContext.Provider value={{
      searchResults,
      setSearchResults,
      hasActiveSearch,
      setHasActiveSearch,
    }}
    >
      {children}
    </SearchContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext must be used within a <SearchProvider>');
  }
  return context;
};
